module.exports = __webpack_public_path__ + "img/client4.8ee4e354.svg";